import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import colors from '../../styles/colors'

const hourOptionsStart = [
  // 오전, 오후 제거
  { value: '00', label: '0시' },
  { value: '01', label: '1시' },
  { value: '02', label: '2시' },
  { value: '03', label: '3시' },
  { value: '04', label: '4시' },
  { value: '05', label: '5시' },
  { value: '06', label: '6시' },
  { value: '07', label: '7시' },
  { value: '08', label: '8시' },
  { value: '09', label: '9시' },
  { value: '10', label: '10시' },
  { value: '11', label: '11시' },
  { value: '12', label: '12시' },
  { value: '13', label: '13시' },
  { value: '14', label: '14시' },
  { value: '15', label: '15시' },
  { value: '16', label: '16시' },
  { value: '17', label: '17시' },
  { value: '18', label: '18시' },
  { value: '19', label: '19시' },
  { value: '20', label: '20시' },
  { value: '21', label: '21시' },
  { value: '22', label: '22시' },
  { value: '23', label: '23시' },
]

const hourOptions = [
  // 오전, 오후 제거
  { value: '00', label: '0시' },
  { value: '01', label: '1시' },
  { value: '02', label: '2시' },
  { value: '03', label: '3시' },
  { value: '04', label: '4시' },
  { value: '05', label: '5시' },
  { value: '06', label: '6시' },
  { value: '07', label: '7시' },
  { value: '08', label: '8시' },
  { value: '09', label: '9시' },
  { value: '10', label: '10시' },
  { value: '11', label: '11시' },
  { value: '12', label: '12시' },
  { value: '13', label: '13시' },
  { value: '14', label: '14시' },
  { value: '15', label: '15시' },
  { value: '16', label: '16시' },
  { value: '17', label: '17시' },
  { value: '18', label: '18시' },
  { value: '19', label: '19시' },
  { value: '20', label: '20시' },
  { value: '21', label: '21시' },
  { value: '22', label: '22시' },
  { value: '23', label: '23시' },
  { value: '24', label: '24시' },
]

// 분 선택 옵션
const minuteOptions = [
  { value: '00', label: '00분' },
  { value: '10', label: '10분' },
  { value: '20', label: '20분' },
  { value: '30', label: '30분' },
  { value: '40', label: '40분' },
  { value: '50', label: '50분' },
  // 분 옵션들 추가
]

const minuteOptionsZero = [{ value: '00', label: '00분' }]

const TimePicker = ({
  onTimeChange,
  isDropdownDisabled,
  isDropdownHourDisabledStart,
  isDropdownMinuteDisabledStart,
  isDropdownHourDisabledEnd,
  isDropdownMinuteDisabledEnd,
  setIsDropdownHourDisabledStart,
  setIsDropdownMinuteDisabledStart,
  setIsDropdownHourDisabledEnd,
  setIsDropdownMinuteDisabledEnd,
  defaultStart,
  defaultEnd,
  type,
}) => {
  const [hour, setHour] = useState('')
  const [minute, setMinute] = useState('')
  const [minuteOption, setMinuteOption] = useState(minuteOptions)

  useEffect(() => {
    // 시작 설정
    if (defaultStart !== '' && typeof defaultStart === 'string') {
      let startTime =
        defaultStart.length === 4
          ? defaultStart.substr(0, 2)
          : `0${defaultStart.substr(0, 1)}`

      // 24이면 0으로 변경
      // 선택 옵션에 24가 없음
      // if (startTime === '24') {
      //   startTime = '00'
      // }

      let hourOpt = hourOptionsStart.filter(
        (ele, i) => ele.value === startTime,
      )[0]

      let endTime =
        defaultStart.length === 4
          ? defaultStart.substr(2, 4)
          : `0${defaultStart.substr(1, 3)}`
      if (endTime === '24') {
        endTime = '00'
      }

      let minuteOpt = minuteOptions.filter((ele, i) => ele.value === endTime)[0]

      handleHourChange(hourOpt)
      handleMinuteChange(minuteOpt)
    }

    // 종료 설정
    if (defaultEnd !== '' && typeof defaultEnd === 'string') {
      let startTime =
        defaultEnd.length === 4
          ? defaultEnd.substr(0, 2)
          : `0${defaultEnd.substr(0, 1)}`

      // 24이면 0으로 변경
      // 선택 옵션에 24가 없음
      // if (startTime === '24') {
      //   startTime = '00'
      // }

      let hourOpt = hourOptions.filter((ele, i) => ele.value === startTime)[0]

      let endTime =
        defaultEnd.length === 4
          ? defaultEnd.substr(2, 4)
          : `0${defaultEnd.substr(1, 3)}`

      // if (endTime === '24') {
      //   endTime = '00'
      // }

      let minuteOpt = minuteOptions.filter((ele, i) => ele.value === endTime)[0]

      handleHourChange(hourOpt)
      handleMinuteChange(minuteOpt)
    }
  }, [defaultStart, defaultEnd])

  useEffect(() => {
    // hour, minute이 빈 문자열이라 기존 데이터가 NaN로 변경됨
    // 조건 추가
    if (hour !== '' && minute !== '') {
      onTimeChange(hour, minute)
    }
    // onTimeChange(hour, minute)
  }, [hour, minute])

  // 시간 선택 핸들러
  const handleHourChange = (selectedOption) => {
    if (!selectedOption) return
    setHour(selectedOption)

    // console.log('selectedOption', selectedOption)

    if (selectedOption.value === '24' && type === 'end') {
      setMinute({ value: '00', label: '00분' })
      setMinuteOption(minuteOptionsZero)
    } else {
      // 24시가 아닌 경우, 분 옵션을 기본값인 minuteOptions로 변경
      setMinuteOption(minuteOptions)
    }

    // 24시일 때 분 드롭다운 비활성화
    // if (selectedOption.value === '24' && type === 'end') {
    //   setHour(selectedOption)
    //   setIsDropdownMinuteDisabledStart(false)
    //   setIsDropdownMinuteDisabledEnd(true)
    // } else {
    //   setHour(selectedOption)
    //   setIsDropdownMinuteDisabledStart(false)
    //   setIsDropdownMinuteDisabledEnd(false)
    // }
  }

  // 분 선택 핸들러
  const handleMinuteChange = (selectedOption) => {
    // console.log('selectedOption min', selectedOption)
    if (!selectedOption) return
    setMinute(selectedOption)
  }

  // 오전 오후
  // const handlePeriodChange = (selectedOption) => {
  //   setSelectedPeriod(selectedOption)
  // }

  // for (let i = 1; i <= 12; i++) {
  //   const hour = i.toString().padStart(2, '0')
  //   hourOptions.push({ value: hour, label: hour + '시' })
  // }

  // const periodOptions = [
  //   { value: 'AM', label: '오전' },
  //   { value: 'PM', label: '오후' },
  // ]

  // console.log('$$ hour', hour)

  return (
    <Container>
      {/* <SelectTime
        options={periodOptions}
        value={selectedPeriod}
        onChange={handlePeriodChange}
        placeholder="오전"
        isDisabled={isDropdownDisabled}
      /> */}
      <SelectHours
        options={type === 'start' ? hourOptionsStart : hourOptions}
        value={hour}
        onChange={handleHourChange}
        placeholder="시간"
        isDisabled={isDropdownDisabled}
      />
      <SelectMinutes
        options={minuteOption}
        value={minute}
        onChange={handleMinuteChange}
        placeholder="분"
        isDisabled={isDropdownDisabled}
      />
    </Container>
  )
}
export default TimePicker

const Container = styled.div`
  display: flex;
  flex: 1;
  /* gap: 10px; */

  @media ${(props) => props.theme.mobile} {
    /* gap: 0.5rem; */
  }
`

const SelectHours = styled(Select)`
  color: ${colors.BK};
  /* width: 123px; */
  width: 145px;
  height: 48px;
  margin-right: 10px;

  @media ${(props) => props.theme.mobile} {
    width: 169px;
    height: 36px;

    .css-1nmdiq5-menu {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: ${colors.BK};
    }
  }
  .css-tr4s17-option {
    background-color: ${colors.lightG};
    color: ${colors.BK};
  }
  .css-t3ipsp-control:hover,
  .css-t3ipsp-control:not(:hover) {
    border-color: ${colors.G3};
    /* border-color: ${colors.G1}; */
    box-shadow: none;
  }
  .css-16xfy0z-control,
  .css-t3ipsp-control {
    /* width: 123px; */
    width: 100%;
    height: 48px;
    @media ${(props) => props.theme.mobile} {
      /* width: 169px; */
      height: 36px;
    }
  }
  .css-13cymwt-control {
    border-color: ${colors.G3};
    /* border-color: ${colors.G1}; */
    width: 100%;
    height: 100%;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  .css-1dimb5e-singleValue {
    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  .css-d7l1ni-option {
    background-color: ${colors.W1};
  }
  .css-d7l1ni-option:hover {
    background-color: ${colors.lightG};
  }
  .css-1u9des2-indicatorSeparator {
    width: 0px;
  }

  .css-1xc3v61-indicatorContainer {
    padding-left: 0;
  }
  .css-1fdsijx-ValueContainer {
    padding: 0;
    padding-left: 10px;
  }
  .css-qbdosj-Input {
    margin: 0;
    padding: 0;
  }
`

const SelectMinutes = styled(Select)`
  color: ${colors.BK};
  /* width: 96px; */
  flex: 1;
  height: 48px;
  @media ${(props) => props.theme.mobile} {
    /* width: 90px; */
    /* width: 130px; */
    height: 36px;
    .css-1nmdiq5-menu {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: ${colors.BK};
      font-size: 14px;
    }
  }
  .css-tr4s17-option {
    background-color: ${colors.lightG};
    color: ${colors.BK};
  }
  .css-t3ipsp-control:hover,
  .css-t3ipsp-control:not(:hover) {
    border-color: ${colors.G3};
    /* border-color: ${colors.G1}; */
    box-shadow: none;
  }
  .css-16xfy0z-control,
  .css-t3ipsp-control {
    /* width: 96px; */
    width: 100%;
    height: 48px;
  }
  @media ${(props) => props.theme.mobile} {
    .css-16xfy0z-control,
    .css-t3ipsp-control {
      /* width: 90px; */
      height: 36px;
    }
  }
  .css-b62m3t-containe {
    width: 90px;
    height: 36px;
  }
  .css-13cymwt-control {
    border-color: ${colors.G3};
    /* border-color: ${colors.G1}; */
    width: 100%;
    height: 100%;
  }
  .css-d7l1ni-option {
    background-color: ${colors.W1};
  }
  .css-d7l1ni-option:hover {
    background-color: ${colors.lightG};
  }
  .css-1u9des2-indicatorSeparator {
    width: 0px;
  }
  @media ${(props) => props.theme.mobile} {
  }

  .css-1fdsijx-ValueContainer {
    padding: 0 0 0 10px;
  }

  .css-1xc3v61-indicatorContainer {
    padding-left: 0px;
  }

  .css-qbdosj-Input {
    margin: 0;
    padding: 0;
  }

  .css-1dimb5e-singleValue {
    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
`

{
  /* <div class=" css-1nmdiq5-menu" id="react-select-2-listbox">
        <div class=" css-1n6sfyn-MenuList">
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-0"
            tabindex="-1"
          >
            밤 12시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-1"
            tabindex="-1"
          >
            오전 1시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-2"
            tabindex="-1"
          >
            오전 2시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-3"
            tabindex="-1"
          >
            오전 3시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-4"
            tabindex="-1"
          >
            오전 4시
          </div>
          <div
            class=" css-tr4s17-option"
            aria-disabled="false"
            id="react-select-2-option-5"
            tabindex="-1"
          >
            오전 5시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-6"
            tabindex="-1"
          >
            오전 6시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-7"
            tabindex="-1"
          >
            오전 7시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-8"
            tabindex="-1"
          >
            오전 8시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-9"
            tabindex="-1"
          >
            오전 9시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-10"
            tabindex="-1"
          >
            오전 10시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-11"
            tabindex="-1"
          >
            오전 11시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-12"
            tabindex="-1"
          >
            낮 12시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-13"
            tabindex="-1"
          >
            오후 1시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-14"
            tabindex="-1"
          >
            오후 2시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-15"
            tabindex="-1"
          >
            오후 3시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-16"
            tabindex="-1"
          >
            오후 4시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-17"
            tabindex="-1"
          >
            오후 5시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-18"
            tabindex="-1"
          >
            오후 6시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-19"
            tabindex="-1"
          >
            오후 7시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-20"
            tabindex="-1"
          >
            오후 8시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-21"
            tabindex="-1"
          >
            오후 9시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-22"
            tabindex="-1"
          >
            오후 10시
          </div>
          <div
            class=" css-10wo9uf-option"
            aria-disabled="false"
            id="react-select-2-option-23"
            tabindex="-1"
          >
            오후 11시
          </div>
        </div>
      </div>*/
}
